(function () {
  'use strict';

  if (window.__jhnyKlaviyoTrackingBooted || (window.Shopify && window.Shopify.designMode)) return;
  var node = document.getElementById('JHNYKlaviyoTrackingData');
  if (!node) return;
  var context;
  try { context = JSON.parse(node.textContent); } catch (error) { return; }
  window.__jhnyKlaviyoTrackingBooted = true;

  var PENDING_KEY = 'jhny-klaviyo-predictive-v1';
  var PENDING_AGE = 120000;
  var POLL_WINDOW = 120000;
  var events = [];
  var properties = {};
  var profileVersion = 0;
  var sentProfileVersion = 0;
  var searchPropertyExpiresAt = 0;
  var pageRecorded = false;
  var loginIdentified = false;
  var busy = false;
  var generation = 0;
  var timer = null;
  var pollUntil = 0;
  var wasAllowed = false;
  var pending = readPending();

  function cleanTerm(value) {
    return typeof value === 'string' ? value.replace(/\s+/g, ' ').trim().slice(0, 500) : '';
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'jhny-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function pathOf(value) {
    try { return new URL(value, window.location.href).pathname.replace(/\/$/, '') || '/'; }
    catch (error) { return ''; }
  }

  function forgetPending(id) {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(PENDING_KEY) || 'null');
      if (!id || (saved && saved.id === id)) window.sessionStorage.removeItem(PENDING_KEY);
    } catch (error) {
      try { window.sessionStorage.removeItem(PENDING_KEY); } catch (ignored) {}
    }
  }

  function readPending() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(PENDING_KEY) || 'null');
      if (!saved) return null;
      var age = Date.now() - saved.createdAt;
      if (typeof saved.id !== 'string' || !cleanTerm(saved.term) || !Number.isFinite(age) || age < 0 || age > PENDING_AGE || saved.targetPath !== pathOf(window.location.href)) {
        forgetPending();
        return null;
      }
      return saved;
    } catch (error) {
      forgetPending();
      return null;
    }
  }

  function allowed() {
    try {
      if (!window.JHNYConsent || typeof window.JHNYConsent.allowed !== 'function' || window.JHNYConsent.allowed('marketing') !== true) return false;
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !privacy || typeof privacy.marketingAllowed !== 'function' || privacy.marketingAllowed() === true;
    } catch (error) { return false; }
  }

  function explicitlyDenied(event) {
    if (event && event.detail && (event.detail.marketing === false || event.detail.marketingAllowed === false)) return true;
    try {
      return !!window.JHNYConsent && typeof window.JHNYConsent.allowed === 'function' && window.JHNYConsent.allowed('marketing') === false;
    } catch (error) { return true; }
  }

  function clearTracking() {
    generation += 1;
    events = [];
    properties = {};
    profileVersion = 0;
    sentProfileVersion = 0;
    searchPropertyExpiresAt = 0;
    pending = null;
    forgetPending();
    if (timer) window.clearTimeout(timer);
    timer = null;
    pollUntil = 0;
  }

  function updateProperties(next) {
    Object.keys(next).forEach(function (key) { properties[key] = next[key]; });
    profileVersion += 1;
  }

  function enqueue(name, details, id, pendingId, expiresAt) {
    details.$event_id = id || eventId();
    events.push({ name: name, details: details, pendingId: pendingId || null, expiresAt: expiresAt || 0, attempts: 0, waitForIdentity: false });
  }

  function recordSearch(term, source, url, count, id, pendingId, expiresAt) {
    term = cleanTerm(term);
    if (!term || !allowed()) return;
    var details = { SearchTerm: term, SearchSource: source, URL: url };
    if (typeof count === 'number') details.ResultsCount = count;
    enqueue('JHNY Searched Site', details, id, pendingId, expiresAt);
    updateProperties({
      JHNY_Last_Search: term,
      JHNY_Last_Search_Source: source,
      JHNY_Last_Search_At: new Date().toISOString()
    });
    searchPropertyExpiresAt = expiresAt || 0;
  }

  function expirePendingSearch() {
    var now = Date.now();
    events = events.filter(function (entry) {
      if (!entry.expiresAt || entry.expiresAt > now) return true;
      if (entry.pendingId) forgetPending(entry.pendingId);
      return false;
    });
    if (searchPropertyExpiresAt && searchPropertyExpiresAt <= now) {
      delete properties.JHNY_Last_Search;
      delete properties.JHNY_Last_Search_Source;
      delete properties.JHNY_Last_Search_At;
      searchPropertyExpiresAt = 0;
      profileVersion += 1;
      if (!Object.keys(properties).length) sentProfileVersion = profileVersion;
    }
  }

  function collectCurrentPage() {
    if (!allowed()) return;
    if (pending) {
      var saved = pending;
      pending = null;
      if (Date.now() - saved.createdAt <= PENDING_AGE) {
        recordSearch(saved.term, 'predictive', saved.sourceUrl, null, saved.id, saved.id, saved.createdAt + PENDING_AGE);
      } else forgetPending(saved.id);
    }
    if (pageRecorded) return;
    pageRecorded = true;
    if (context.search) recordSearch(context.search.term, 'search_results', context.url, context.search.resultsCount);
    if (context.product && context.product.id) {
      var product = context.product;
      var tags = Array.isArray(product.tags) ? product.tags.slice() : [];
      var categories = Array.isArray(product.categories) ? product.categories.slice() : [];
      enqueue('JHNY Viewed Product Tags', {
        ProductID: String(product.id),
        ProductName: product.name,
        ProductTags: tags,
        Categories: categories,
        URL: product.url
      });
      updateProperties({
        JHNY_Last_Viewed_Product_ID: String(product.id),
        JHNY_Last_Viewed_Product: product.name,
        JHNY_Last_Viewed_Product_Tags: tags,
        JHNY_Last_Viewed_Product_Categories: categories,
        JHNY_Last_Viewed_Product_At: new Date().toISOString()
      });
    }
  }

  function withinTimeout(value) {
    return new Promise(function (resolve, reject) {
      var timeout = window.setTimeout(function () { reject(new Error('Klaviyo unavailable')); }, 5000);
      Promise.resolve(value).then(function (result) {
        window.clearTimeout(timeout);
        resolve(result);
      }, function (error) {
        window.clearTimeout(timeout);
        reject(error);
      });
    });
  }

  function stillAllowed(startGeneration) {
    return generation === startGeneration && allowed();
  }

  async function flush() {
    if (busy || !allowed()) return;
    collectCurrentPage();
    var sdk = window.klaviyo;
    if (!sdk || typeof sdk.isIdentified !== 'function' || typeof sdk.identify !== 'function' || typeof sdk.track !== 'function') return;
    if (!events.length && profileVersion === sentProfileVersion) return;
    busy = true;
    var startGeneration = generation;
    try {
      var known = await withinTimeout(sdk.isIdentified());
      if (!stillAllowed(startGeneration)) return;
      expirePendingSearch();
      if (!loginIdentified && typeof context.customerEmail === 'string' && context.customerEmail) {
        await withinTimeout(sdk.identify({ email: context.customerEmail }));
        if (!stillAllowed(startGeneration)) return;
        known = await withinTimeout(sdk.isIdentified());
        if (!stillAllowed(startGeneration)) return;
        loginIdentified = known === true;
      }
      expirePendingSearch();
      if (known === true && profileVersion !== sentProfileVersion) {
        var sendingVersion = profileVersion;
        await withinTimeout(sdk.identify(Object.assign({}, properties)));
        if (!stillAllowed(startGeneration)) return;
        sentProfileVersion = sendingVersion;
      }
      var batch = events.slice();
      for (var i = 0; i < batch.length; i += 1) {
        if (!stillAllowed(startGeneration)) return;
        var item = batch[i];
        if (item.expiresAt && item.expiresAt <= Date.now()) {
          expirePendingSearch();
          continue;
        }
        if (item.waitForIdentity && known !== true) continue;
        if (item.attempts >= 3) continue;
        item.attempts += 1;
        var tracked = await withinTimeout(sdk.track(item.name, item.details));
        if (!stillAllowed(startGeneration)) return;
        if (tracked === true) {
          events = events.filter(function (entry) { return entry !== item; });
          if (item.pendingId) forgetPending(item.pendingId);
        } else {
          item.waitForIdentity = known !== true;
        }
      }
    } catch (error) {
    } finally {
      busy = false;
    }
  }

  function hasWork() {
    return !pageRecorded || !!pending || profileVersion !== sentProfileVersion || events.some(function (entry) { return entry.attempts < 3; });
  }

  async function tick() {
    timer = null;
    if (!allowed()) return;
    await flush();
    if (allowed() && hasWork() && Date.now() < pollUntil && !timer) timer = window.setTimeout(tick, 2000);
  }

  function wake(duration) {
    if (!allowed()) return;
    pollUntil = Math.max(pollUntil, Date.now() + (duration || POLL_WINDOW));
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(tick, 0);
  }

  function onConsent(event) {
    var current = allowed();
    if (explicitlyDenied(event) || (wasAllowed && !current)) clearTracking();
    wasAllowed = current;
    if (current) wake();
  }

  function onPredictiveClick(event) {
    if (event.defaultPrevented || !allowed()) return;
    if (typeof event.button === 'number' && event.button !== 0 && event.button !== 1) return;
    var element = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
    var anchor = element && element.closest('a[href]');
    var search = anchor && anchor.closest('predictive-search');
    if (!search || !anchor.closest('[data-predictive-search]')) return;
    var input = search.querySelector('input[name="q"]');
    var term = cleanTerm(input && input.value);
    if (!term) return;
    var destination;
    try { destination = new URL(anchor.href, window.location.href); } catch (error) { return; }
    if (destination.origin !== window.location.origin || !/\/(products|collections|pages|blogs)\//.test(destination.pathname)) return;
    var id = eventId();
    var sourceUrl = window.location.origin + window.location.pathname;
    if (event.button === 1 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || anchor.target === '_blank') {
      recordSearch(term, 'predictive', sourceUrl, null, id);
      wake();
      return;
    }
    try {
      window.sessionStorage.setItem(PENDING_KEY, JSON.stringify({
        id: id,
        term: term,
        createdAt: Date.now(),
        targetPath: pathOf(destination.href),
        sourceUrl: sourceUrl
      }));
    } catch (error) {
      recordSearch(term, 'predictive', sourceUrl, null, id);
      wake();
    }
  }

  window.addEventListener('jhny:consent-changed', onConsent);
  document.addEventListener('visitorConsentCollected', onConsent);
  document.addEventListener('click', onPredictiveClick);
  document.addEventListener('auxclick', onPredictiveClick);
  window.addEventListener('klaviyoForms', function (event) {
    if (event.detail && event.detail.type === 'submit') wake(30000);
  });
  document.addEventListener('jhny:curation', function () { wake(30000); });
  window.addEventListener('focus', function () { wake(30000); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) wake(30000);
  });
  onConsent();
})();
